<template>
  <div :style="style">
    <b-carousel
      ref="myCarousel"
      v-if="urls && urls.length > 1"
      id="carousel-1"
      v-model="slide"
      :controls="!config.fade"
      :img-height="height"
      :interval="interval"
      :indicators="config.indicators"
      :background="config.background"
      style="text-shadow: 1px 1px 2px #333"
      :style="style"
      :fade="config.fade"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <template v-for="(item, index) in urls">
        <b-carousel-slide class="">
          <template v-slot:img>
            <b-img-lazy
              rounded="0"
              class="d-block"
              @click="onClick(item)"
              :src="item.url"
              alt="image slot"
            ></b-img-lazy>
          </template>
        </b-carousel-slide>
        <div
          class="carousel-caption"
          @click="onClick(item)"
          v-show="index == slide"
          v-if="showTitle"
          :style="`min-width:100%;width:${config.width ? config.width : '100%'
            };left:0;font-size:1rem;;position:absolute;bottom:0;margin:0;padding:0;background-color:rgb(0 0 0 / 38%);`"
        >
          <h6 class="m-0 p-1 text-left">{{ item.text }}</h6>
        </div>
      </template>

      <button
        v-if="config.fade"
        class="carousel-control-prev"
        type="button"
        data-target="#carouselExampleControls"
        data-slide="prev"
        @click="prev"
        style="color: #333"
      >
        <b-icon
          icon="chevron-left"
          scale="2"
          rotate="0"
          shift-h="-8"
          shift-v="8"
          class="text-dark"
        ></b-icon>
        <span class="sr-only"></span>
      </button>
      <button
        v-if="config.fade"
        class="carousel-control-next"
        type="button"
        data-target="#carouselExampleControls"
        data-slide="next"
        @click="next"
      >
        <b-icon
          icon="chevron-right"
          scale="2"
          rotate="0"
          shift-h="-8"
          shift-v="8"
          class="text-dark"
          aria-hidden="true"
        ></b-icon>
      </button>
    </b-carousel>

    <banner
      v-if="urls.length == 1"
      :layout="'img'"
      :url="urls[0].url"
      :height="'auto'"
      :action="action"
      @on-button="$emit('on-button', $enevt)"
    ></banner>
  </div>
</template>

<script>
import store from "@/store";

import banner from "@/components/banner.vue";
// import banner from '@/assets/banner1.png'
export default {
  name: "site-carousel",
  components: { banner },
  props: {
    initUrls: {
      type: [String, Array],
      default() {
        return []; // url
      },
    },
    height: {
      type: [String, Number],
      default() {
        return 300; // url
      },
    },
    interval: {
      type: [String, Number],
      default() {
        return 3000; // url
      },
    },

    activeNavbar: {
      type: [String],
      default() {
        return ""; // url
      },
    },
    action: {
      type: [Object],
      default() {
        return null;
        // {
        //   text:'',
        //   type:'',
        //   params:null,

        // }
      },
    },
    config: {
      type: [Object],
      default() {
        return {
          indicators: true,
        };
      },
    },
    showTitle: {
      type: [Boolean],
      default() {
        return true;
      },
    },
    imageStyle: {
      type: [String],
      default() {
        return ``;
      },
    },
    initColNo: {
      type: [String],
      default() {
        return ""; // url
      },
    },
  },
  computed: {
    options() {
      return {};
    },
    style() {
      let style = {};
      let height = this.height;

      // 响应式高度设置
      if (height) {
        // 移动端适配：使用视口高度的比例
        if (window.innerWidth <= 768) {
          style["height"] = `${Math.min(window.innerWidth / 4, 100)}px`;
          style["max-height"] = `300px`;
        } else {
          style["height"] = `${height}px`;
          style["max-height"] = `${height}px`;
        }
        style["min-height"] = `100px`;
        style["overflow"] = `hidden`;
      }

      if (this.config) {
        style["background"] = this.config.background || "transparent";
        if (this.config.fade) {
          style["color"] = "#ababab";
        }
      }
      return style;
    },
    urls() {
      let imgs = store.getters.getActiveCarousel || [];
      let urls = [];
      if (this.activeNavbar && imgs?.length) {
        for (let img of imgs) {
          let url = this.getFileUrls(img.carousel_img);
          let config = this.webConfig;
          let obj = {
            url: `${config.protocol}://${config.host}:${config.port}/file/download?fileNo=${img.carousel_img}`,
            href: "",
            _data: img,
            text: img.link_content_title || "",
          };
          urls.push(obj);
        }
      } else if (this.initUrls && this.initUrls.length) {
        urls = this.initUrls.map((item) => item);
      }

      return urls;
    },
  },
  mounted() {
    if (this.activeNavbar) {
      this.getOnCarousel(this.activeNavbar);
    }
  },
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  methods: {
    prev() {
      this.$refs.myCarousel.prev();
    },
    next() {
      this.$refs.myCarousel.next();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    getOnCarousel(no) {
      store.dispatch("getActiveNavAction", no);
    },
    onClick(e) {
      // 点击轮播图 回传数据
      this.$emit("on-button", e);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card-img {
  min-height: 8rem;
}

::v-deep .carousel-inner {
  height: 100%;
}

.carousel-item {
  width: 100%;
  height: 100%;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover; // 保持图片比例，避免拉伸
  }
}

#carousel-1 .carousel-item .carousel-caption {
  min-width: 100%;
  left: 0;
  right: 0 !important;
}

// 移动端轮播图优化
@media (max-width: 768px) {

  ::v-deep .carousel-control-prev,
  ::v-deep .carousel-control-next {
    width: 15%;
    opacity: 0.8;
  }

  ::v-deep .carousel-indicators {
    bottom: 10px;

    li {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin: 0 3px;
    }
  }

  .carousel-caption {
    padding: 0.5rem !important;

    h6 {
      font-size: 0.9rem !important;
      line-height: 1.2 !important;
    }
  }
}

// 触摸滑动优化
::v-deep .carousel {
  touch-action: pan-y pinch-zoom;
}
</style>